<template>
  <div class="md-layout">
    <md-toolbar
      id="departure_manifest_header"
      md-elevation="0"
      class="md-transparent"
    >
      <div class="md-toolbar-row">
        <div class="md-toolbar-section-start">
          <md-button
            :disabled="departure == null"
            class="md-raised md-dense md-success"
            @click.prevent="downloadManifest"
          >
            <md-icon>file_download</md-icon>
            Download Manifest</md-button
          >
        </div>
      </div>
      <div class="md-toolbar-row">
        <div
          v-if="guides.length > 0"
          class="md-toolbar-section-start guide-names"
        >
          <div>
            <div>
              <strong>Guides: </strong>
              <span>{{ guideList }}</span>
            </div>
          </div>
        </div>
      </div>
    </md-toolbar>

    <div class="md-layout-item md-size-100">
      <traveller-list :manifest="manifest"></traveller-list>
    </div>

    <div
      class="md-layout-item md-size-100"
      v-if="$allowed('departure.manifest.manage')"
    >
      <itinerary-list
        :manifest="manifest"
        :departure="departure"
        @manifestChanged="manifestChanged"
      ></itinerary-list>
    </div>
    <div
      class="md-layout-item md-size-100"
      v-if="$allowed('departure.manifest.manage')"
    >
      <dinners-list
        :manifest="manifest"
        :departure="departure"
        @manifestChanged="manifestChanged"
      ></dinners-list>
    </div>
    <div
      class="md-layout-item md-size-100"
      v-if="$allowed('departure.manifest.manage')"
    >
      <reservations-list
        :manifest="manifest"
        :departure="departure"
        @manifestChanged="manifestChanged"
      ></reservations-list>
    </div>
    <div class="md-layout-item md-size-50">
      <pickups-list
        :manifest="manifest"
        :departure-id="departureId"
        @manifestChanged="manifestChanged"
      ></pickups-list>
    </div>
    <div class="md-layout-item md-size-50">
      <notes-list
        :manifest="manifest"
        :departure-id="departureId"
        @manifestChanged="manifestChanged"
      ></notes-list>
    </div>
  </div>
</template>
<script>
import departureApi from "@/services/api/departure";
import sanitizeFilename from "sanitize-filename";
import _filter from "lodash/filter";

import TravellerList from "./Manifest/TravellerList.vue";
import NotesList from "./Manifest/NotesList.vue";
import PickupsList from "./Manifest/PickupsList.vue";
import ItineraryList from "./Manifest/ItineraryList.vue";
import DinnersList from "./Manifest/DinnerList.vue";
import ReservationsList from "./Manifest/ReservationsList.vue";

export default {
  data() {
    return {
      departure: null,
      manifest: {
        id: null,
        notes: "",
        pickups: "",
        bookings: [],
        itinerary: [],
        dinners: [],
        reservations: []
      },
      guides: []
    };
  },

  components: {
    TravellerList,
    NotesList,
    PickupsList,
    ItineraryList,
    DinnersList,
    ReservationsList
  },

  methods: {
    getDeparture(tourId, departureId) {
      departureApi.getDeparture(tourId, departureId).then(response => {
        this.departure = response.data;
        this.getDepartureGuides(this.departure);
      });
    },

    getManifest(departureId) {
      departureApi.getManifest(departureId).then(response => {
        this.manifest = response.data.manifest;
      });
    },

    getDepartureGuides(departure) {
      departureApi.getGuides(departure).then(response => {
        this.guides = response.data;
      });
    },

    downloadManifest() {
      departureApi.downloadManifest(this.departure.id).then(response => {
        let manifest = window.URL.createObjectURL(new Blob([response]));
        let docUrl = document.createElement("a");

        let tour = this.departure.tour.title.toLowerCase().replace(" ", "_");
        let filename = `manifest-${this.departure.start_date}-${tour}.pdf`;

        docUrl.href = manifest;
        docUrl.setAttribute("download", filename);
        document.body.appendChild(docUrl);
        docUrl.click();
      });
    },

    manifestChanged(manifest) {
      this.manifest = manifest;
    }
  },

  computed: {
    departureId() {
      return this.$route.params.departure_id;
    },
    tourId() {
      return this.$route.params.tour_id;
    },
    guideList() {
      return this.guides.map(a => a.full_name).join(", ");
    }
  },

  created() {
    this.getDeparture(this.tourId, this.departureId);
    this.getManifest(this.departureId);
  },

  beforeRouteUpdate(to, from, next) {
    next();
    this.getDeparture(this.tourId, this.departureId);
    this.getManifest(this.departureId);
  }
};
</script>
<style lang="scss">
#departure_manifest_header {
  margin-bottom: 2rem;

  .guide-names {
    margin-top: 2rem;
  }
}
</style>
